module.exports = __webpack_public_path__ + "static/media/marluce_gaviao.0dbbb4ea.png";